<template>
  <div class="project-manager">
    <template v-if="!canManageProjectOwner">
      <span v-if="item.project_owners.length">
        <span v-for="pm in item.project_owners" :key="pm">
          {{
            `${pm.first_name || pm.firstname || ''} ${
              pm.last_name || pm.lastname || ''
            }`.trim()
          }}
        </span>
      </span>
      <span v-else>{{ $t('none') }}</span>
    </template>
    <project-manager-dropdown
      :values="assignedProjectManagers(item)"
      :projectId="item.project.id"
      :projectManagers="projectManagers"
      v-if="canManageProjectOwner"
      @add="addProjectManager"
      @remove="removeProjectManager"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ProjectManagerDropdown from '@/components/ProjectManagerDropdown.vue';
import ProjectManagerRoleMixin from '@/mixins/ProjectManagerRoleMixin';

export default {
  name: 'JobProjectManager',
  mixins: [ProjectManagerRoleMixin],
  components: {
    ProjectManagerDropdown,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    projectManagers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    assignedProjectManagers() {
      return (item) => {
        if (item && item.project_owners && item.project_owners.length) {
          return item.project_owners.map((entry) => ({
            value: entry.sfid || entry.id,
            text: `${entry.first_name || entry.firstname || ''} ${
              entry.last_name || entry.lastname || ''
            }`.trim(),
          }));
        }
        return [];
      };
    },
  },
  methods: {
    async addProjectManager(projectId, sfid) {
      try {
        await axios.put(`/api/brand/projects/add-project-owner`, {
          project_id: `${projectId}`,
          contact_sfid: sfid,
        });
        const pmInfo = this.projectManagers.find((pm) => pm.value === sfid);
        const [firstName, ...lastParts] = (pmInfo?.text || '').split(' ');
        const newOwner = {
          sfid,
          first_name: firstName || '',
          last_name: lastParts.join(' ') || '',
        };
        this.item.project_owners = [
          ...(this.item.project_owners || []),
          newOwner,
        ];
      } catch (e) {
        throw new Error(e);
      }
    },
    async removeProjectManager(projectId, sfid) {
      try {
        await axios.delete(`/api/brand/projects/remove-project-owner`, {
          data: {
            project_id: `${projectId}`,
            contact_sfid: sfid,
          },
        });
        this.item.project_owners = (this.item.project_owners || []).filter(
          (po) => po.sfid !== sfid,
        );
      } catch (e) {
        throw new Error(e);
      }
    },
  },
};
</script>
